module.exports = __webpack_public_path__ + "static/media/arrowUpLight.93835040.svg";